/* eslint-disable jsx-a11y/interactive-supports-focus */
import classNames from "classnames";
import { CORPORATE_ENVIRONMENT_TYPE, CORPORATE_GROUP_ENVIRONMENT_TYPE } from "constants.js";
import A11yNav from "pages/_components/A11yNav";
import Box from "pages/_components/Box";
import Button from "pages/_components/Button";
import DraggableList from "pages/_components/DraggableList";
import Dropdown from "pages/_components/Dropdown";
import EntrustDisclaimerComponent from "pages/_components/EntrustDisclaimer/EntrustDisclaimerComponent";
import FastRechargeCarousel from "pages/_components/FastRechargeCarousel";
import GeneralMsg from "pages/_components/GeneralMsg";
import Head from "pages/_components/Head";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import Row from "pages/_components/Row";
import ScheduledTransactionsMigrationDisclaimer from "pages/_components/ScheduledTransactionsMigrationDisclaimer/ScheduledTransactionsMigrationDisclaimer";
import ShortCuts from "pages/_components/ShortCuts";
import Text from "pages/_components/Text";
import Header from "pages/_components/header/Header";
import TextAndButtonsModal from "pages/_components/modal/TextAndButtonsModal";
import ConfirmDialog from "pages/_components/modal/ConfirmDialog";
import Campaigns from "pages/campaigns/Campaigns";
import * as Widgets from "pages/desktop/widgets";
import BiometricModal from "pages/login/_components/BiometricModal";
import fieldARP from "pages/servicePayments/hooks/field";
import { arrayOf, bool, func, number, shape, string } from "prop-types";
import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import { actions, selectors as desktopSelectors } from "reducers/desktop";
import { selectors as loginSelectors } from "reducers/login";
import { actions as notificationActions } from "reducers/notification";
import { actions as payServiceActions, selectors as payServiceSelectors } from "reducers/payService";
import { actions as productRequestActions } from "reducers/productRequest";
import { actions as transactionalProfileActions } from "reducers/transactionalProfile";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as updateCompanyDataActions } from "reducers/updateCompanyData/updateCompanyData.reducer";
import { get as getConfig, getBoolean } from "util/config";
import * as deviceUtils from "util/device";
import * as i18n from "util/i18n";
import * as stringUtils from "util/string";
import { actions as updateUserDataActions } from "reducers/updateUserData/updateUserData.reducer";
import SideBarModal from "pages/_components/modal/SideBarModal";
import TokeStatusQR from "pages/settings/TokenStatusQR";
import { ENABLED_CONFIG_MONITOR_DBF } from "util/monitor/monitorDbf.utils";
import EconomicGroups from "./widgets/economicGroup/EconomicGroups";

// eslint-disable-next-line max-len
class Desktop extends Component {
    mySectionRef = React.createRef();

    SHOW_REQUEST_PRODUCTS = "showRequestProducts";

    SHOW_TRANSACTIONAL_PROFILE = "showTransactionalProfile";

    SHOW_DATA_UPDATE = "showDataUpdate";

    static propTypes = {
        dispatch: func.isRequired,
        layout: arrayOf(
            shape({
                column: number,
                id: string,
                row: number,
                uri: string,
            }),
        ).isRequired,
        isDesktop: bool,
        isTablet: bool,
        availableWidgets: arrayOf(
            shape({
                column: number,
                id: string,
                row: number,
                uri: string,
            }),
        ).isRequired,
        isEditable: bool,
        sessionFetching: bool,
        desktopFetching: bool,
        user: shape({
            userFullName: string,
            userFirstName: string,
        }),
        activeEnvironment: shape({ type: string }).isRequired,
        displayCampaigns: bool,
        urlFooterBanner: string,
        location: shape({}),
        isMobile: bool,
        showUpdateDataModal: bool,
        daysSinceLastUpdt: number,
        showUpdateCorporateDataModal: bool,
        yearsSinceLastUpdtCorporate: number,
        isAdministrator: bool,
        match: shape({}),
        listPayService: arrayOf(shape({})),
        payServiceFetching: bool,
        showMonitorFraudModal: bool.isRequired,
        creditLinesList: arrayOf(shape({})),
        drawerTokenStatusType: string,
        showDrawerStatusToken: bool,
    };

    static defaultProps = {
        isDesktop: false,
        isTablet: false,
        isEditable: null,
        sessionFetching: null,
        desktopFetching: null,
        displayCampaigns: null,
        user: null,
        urlFooterBanner: null,
        location: {},
        isMobile: false,
        showUpdateDataModal: false,
        daysSinceLastUpdt: 0,
        showUpdateCorporateDataModal: false,
        yearsSinceLastUpdtCorporate: 0,
        isAdministrator: false,
        match: undefined,
        listPayService: [],
        payServiceFetching: false,
        creditLinesList: [],
        drawerTokenStatusType: undefined,
        showDrawerStatusToken: false,
    };

    state = {
        showDeleteWidgetModal: false,
        widgetToDelete: null,
    };

    componentDidMount() {
        const {
            dispatch,
            layout,
            isDesktop,
            activeEnvironment: { type },
        } = this.props;
        if (layout === null || layout === undefined || !layout) {
            dispatch(actions.loadLayoutRequest());
        }
        this.showAlertTokenInvalid();

        if (!isDesktop) {
            this.mainElement = document.querySelector("main");
            if (this.mainElement) {
                this.mainElement.addEventListener("scroll", this.handleScroll);
            }
        }

        if (window.location.href.includes("desktop")) {
            this.showRedirectionModal(window.location.href, type);
        }
    }

    componentWillUnmount() {
        const { isDesktop, dispatch } = this.props;
        dispatch(actions.hideMonitorFraudModal());
        if (!isDesktop && this.mainElement) {
            this.mainElement.removeEventListener("scroll", this.handleScroll);
        }
    }

    showAlertTokenInvalid = () => {
        const { dispatch, match } = this.props;
        if (!deviceUtils.isMobileNativeFunc() || !match?.params?.id) {
            return;
        }

        const showAlertTokenInvalid = match.params.id;
        if (showAlertTokenInvalid === 1 || showAlertTokenInvalid === "1") {
            dispatch(
                notificationActions.showNotification(i18n.get("transaction.invalid.otp.required.mobile"), "error", [
                    "desktop",
                ]),
            );
        }
    };

    hideDeleteWidgetModal = () => {
        this.setState({ showDeleteWidgetModal: false, widgetToDelete: null });
    };

    handleCloseUpdateModal = () => {
        const { dispatch } = this.props;
        dispatch(actions.updateModalHide());
    };

    displayUpdateCompanyDataStepZero = () => {
        const { dispatch } = this.props;
        dispatch(actions.updateCorporateModalHide());
        dispatch(updateCompanyDataActions.showUpdateCompanyDataStepZero());
    };

    handleCloseUpdateCorporteModal = () => {
        const { dispatch } = this.props;
        dispatch(actions.updateCorporateModalHide());
    };

    showDeleteWidgetModal = (item) => {
        this.setState({ showDeleteWidgetModal: true, widgetToDelete: item });
    };

    getColumns = (layout) =>
        layout?.reduce((obj, item) => {
            const columnValue = obj[item.column] || [];

            return { ...obj, [item.column]: [...columnValue, item] };
        }, {});

    handleClick = () => {
        const { widgetToDelete } = this.state;
        const { dispatch, layout } = this.props;
        const { column, row } = widgetToDelete;

        dispatch(actions.deleteWidget(layout?.findIndex((widget) => widget.column === column && widget.row === row)));
        this.setState({ showDeleteWidgetModal: false, widgetToDelete: null });
    };

    handleIsEditableChange = () => {
        const { dispatch } = this.props;
        dispatch(actions.toggleIsEditable());
    };

    handleItemsPositionChange = (items) => {
        const { dispatch } = this.props;

        dispatch(actions.setLayout(items));
        dispatch(actions.saveLayoutRequest());
    };

    handleLinkFastRecharge = (paymentUser) => {
        const { dispatch } = this.props;
        const newPaymentUser = { ...paymentUser, fastRecharge: true };
        dispatch(payServiceActions.isLinkFastRecharge(true));

        const query = {
            paymentUser: newPaymentUser,
            biller: paymentUser?.extraData,
            savePayment: false,
            isFastRecharge: true,
        };
        dispatch(payServiceActions.setQueryBillPre(query));
        dispatch(payServiceActions.setSelectedBiller(paymentUser?.extraData));

        // Telered -> consulta de reglas
        if (paymentUser?.extraData?.svcProviderId === "Telered") {
            dispatch(payServiceActions.listRulesBillerRequest(paymentUser?.idBiller));
        } else {
            // ARP -> definicion de reglas por defecto
            dispatch(payServiceActions.listRulesBillerSuccess(fieldARP));
        }
        dispatch(routerActions.push("/formCustom/servicePayment"));
    };

    renderHeader = () => {
        const {
            isDesktop,
            dispatch,
            availableWidgets,
            isEditable,
            activeEnvironment: { type },
            user,
            creditLinesList,
        } = this.props;

        const availableWidgetsToShow = availableWidgets.filter(
            (widget) => widget.id !== "creditLines" || (widget.id === "creditLines" && creditLinesList.length > 0),
        );

        const hasAvailableWidgets = availableWidgetsToShow.length > 0;
        const title = "menu.desktop";
        const { userFirstName } = user;

        if (!isDesktop) {
            return (
                <Head contentLeft dashboard title={title} userFullName={userFirstName} userFirstName={userFirstName} />
            );
        }

        return (
            <>
                <Header>
                    <Text
                        className="toolbar-item view-title data-label display-block"
                        component="h3"
                        labelKey="desktop.welcome"
                        username={userFirstName}
                    />

                    {type !== CORPORATE_GROUP_ENVIRONMENT_TYPE && (
                        <div className="toolbar-item desktop-edit toolbar-item--fixed">
                            {!isEditable ? (
                                <Button
                                    label="desktop.editLayout.edit.label"
                                    onClick={() => this.handleIsEditableChange()}
                                    bsStyle="link"
                                    id="editDashboardBtn"
                                />
                            ) : (
                                <>
                                    {hasAvailableWidgets ? (
                                        <Dropdown
                                            enabled={isEditable}
                                            label="desktop.selectWidget"
                                            buttonClass="btn-select">
                                            {availableWidgetsToShow.map((widget, index) => (
                                                // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                                                <Button
                                                    key={widget.id}
                                                    onClick={() => dispatch(actions.addWidget(index))}
                                                    label={`list.addWidget.${widget.id}`}
                                                    className="dropdown__item-btn"
                                                    bsStyle="link"
                                                />
                                            ))}
                                        </Dropdown>
                                    ) : (
                                        <I18n
                                            id="desktop.widgets.empty"
                                            componentProps={{ className: "desktop-edit-empty-message" }}
                                        />
                                    )}
                                    <Button
                                        bsStyle="only-icon"
                                        image="images/icons/circleCross.svg"
                                        className="widget-edit-close"
                                        label="desktop.editLayout.finish.label"
                                        defaultLabelText="Terminar edición"
                                        onClick={() => this.handleIsEditableChange()}
                                    />
                                </>
                            )}
                        </div>
                    )}
                </Header>
            </>
        );
    };

    renderItem = (item, { draggableItemProps }) => {
        const { isEditable, isDesktop } = this.props;

        const Widget = Widgets[stringUtils.capitalizeFirstLetter(item.id)];
        const buttonActionDesc = `${i18n.get("global.close")} ${i18n.get("global.widget")}, ${i18n.get(
            `list.addWidget.${item.id}`,
        )}`;
        return (
            <>
                <Widget
                    className={classNames({ "draggable-list__item": isEditable })}
                    closeButton={
                        isEditable && (
                            <Button
                                className="btn-link btn-only-icon widget-close-icon"
                                onClick={() => this.showDeleteWidgetModal(item)}>
                                {/* onClick={() => this.handleClick(item)}> */}
                                <Image src="images/icons/circleCross.svg" />
                                <span className="visually-hidden">{buttonActionDesc}</span>
                            </Button>
                        )
                    }
                    draggableItemProps={draggableItemProps}
                    isEditable={isEditable}
                    isDesktop={isDesktop}
                />
            </>
        );
    };

    redirectTrasferShortCut = (transferUrl) => {
        const { dispatch } = this.props;
        dispatch(routerActions.push(transferUrl));
    };

    getTransferUrlShortCut = () => {
        const { activeEnvironment, dispatch } = this.props;
        if (activeEnvironment?.permissions?.transferInternal) {
            this.redirectTrasferShortCut("/formCustom/transferInternal");
            return;
        }
        if (activeEnvironment?.permissions?.transferLocal || activeEnvironment?.permissions?.transferThirdParties) {
            this.redirectTrasferShortCut("/formCustom/transferLocal");
            return;
        }
        if (activeEnvironment?.permissions?.transferForeign) {
            this.redirectTrasferShortCut("/formCustom/transferForeign");
            return;
        }

        dispatch(notificationActions.showNotification(i18n.get("returnCode.COR005E"), "error", ["desktop"]));
    };

    scrollToPreApproved = () => {
        const element = document.getElementById("preApprovedSection");
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    isElementVisible = (el) => {
        const rect = el?.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        return rect.top >= 0 && rect.bottom <= windowHeight;
    };

    showRedirectionModal = (redirection, type) => {
        const { dispatch } = this.props;

        if (redirection.includes(this.SHOW_REQUEST_PRODUCTS)) {
            dispatch(productRequestActions.modalShow());
        }

        if (redirection.includes(this.SHOW_TRANSACTIONAL_PROFILE)) {
            dispatch(transactionalProfileActions.transactionalCountriesSettingRequest());
            dispatch(transactionalProfileActions.modalShow({}, true));
        }

        if (redirection.includes(this.SHOW_DATA_UPDATE)) {
            if (type === CORPORATE_ENVIRONMENT_TYPE) {
                dispatch(updateCompanyDataActions.showUpdateCompanyDataStepZero());
            } else {
                dispatch(updateUserDataActions.showUpdateUserDataStepZero());
            }
        }
    };

    hasModalShow = () =>
        [this.SHOW_DATA_UPDATE, this.SHOW_REQUEST_PRODUCTS, this.SHOW_TRANSACTIONAL_PROFILE].some((item) =>
            window.location.href.includes(item),
        );

    getAccessToUpdateData = () => {
        const { dispatch } = this.props;
        dispatch(actions.updateModalHide());
        dispatch(updateUserDataActions.validateClientRemediation());
    };

    renderModalUpdateDataUser = () => {
        const enabledMonitorDbf = getConfig(ENABLED_CONFIG_MONITOR_DBF, "0");
        if (!enabledMonitorDbf !== "1") {
            return <div />;
        }

        const { activeEnvironment, daysSinceLastUpdt, showUpdateDataModal, user } = this.props;
        const { userFirstName } = user;
        const headingTextMessageUpdateModal = i18n.get("widgets.updateModal.headingText", null, {
            CLIENT: userFirstName,
        });
        const infoMessageUpdateModal = i18n.get("widgets.updateModal.text", null, {
            DAYS: daysSinceLastUpdt,
        });
        const isAccessToUpdateDataEnabled = getBoolean("settings.userData.accessFromModal.enabled");
        return activeEnvironment?.type &&
            activeEnvironment.type !== CORPORATE_ENVIRONMENT_TYPE &&
            isAccessToUpdateDataEnabled ? (
            <TextAndButtonsModal
                modalShow={showUpdateDataModal}
                acceptFunction={this.getAccessToUpdateData}
                cancelFunction={this.handleCloseUpdateModal}
                headingText={headingTextMessageUpdateModal}
                text={infoMessageUpdateModal}
                confirmLabel="widgets.updateModal.confirmLabel"
                cancelLabel="widgets.updateModal.cancelLabel"
                modalId="widgets.update.data.modal"
            />
        ) : (
            <TextAndButtonsModal
                modalShow={showUpdateDataModal}
                externalHref={getConfig("desktop.link.to.update")}
                cancelFunction={this.handleCloseUpdateModal}
                headingText={headingTextMessageUpdateModal}
                text={infoMessageUpdateModal}
                confirmLabel="widgets.updateModal.confirmLabel"
                cancelLabel="widgets.updateModal.cancelLabel"
                modalId="widgets.update.data.modal"
            />
        );
    };

    renderContent = () => {
        const {
            isEditable,
            activeEnvironment: { type },
            sessionFetching,
            desktopFetching,
            layout,
            isDesktop,
            isTablet,
            displayCampaigns,
            location,
            isMobile,
            listPayService,
            creditLinesList,
        } = this.props;

        const layoutToShow = layout?.filter(
            (item) => item.id !== "creditLines" || (item.id === "creditLines" && creditLinesList.length > 0),
        );
        const { showDeleteWidgetModal, widgetToDelete } = this.state;
        const isStepZero = location.pathname === "/";

        const shortCutBtns = [
            {
                image: { desktop: "images/shortCutBtn/SCBaccounts.svg" },
                label: "desktop.widgets.short.cuts.accounts",
                href: "/formCustom/transferInternal",
            },
            {
                image: { desktop: "images/shortCutBtn/SCBthirdParties.svg" },
                label: "desktop.widgets.short.cuts.transferThirdParties",
                href: "/formCustom/transferLocal",
            },
            {
                image: { desktop: "images/shortCutBtn/SCBForeign.svg" },
                label: "desktop.widgets.short.cuts.foreign",
                href: "/formCustom/transferForeign",
            },
        ];

        const textWidgetToDelete = widgetToDelete ? i18n.get(`widgets.hideModal.${widgetToDelete.id}`) : "";
        const infoMessage = i18n.get("widgets.hideModal", null, {
            WIDGET: textWidgetToDelete,
        });

        /* const infoMessageUpdateCorporateModal = i18n.get(
            `administration.updateModal.corporate.text${isMobile ? ".mobile" : ""}`,
            null,
            {
                YEARS: yearsSinceLastUpdtCorporate,
            },
        ); */

        return (
            <>
                <MainContainer
                    className="desktop"
                    showLoader={sessionFetching || desktopFetching}
                    {...(!isDesktop && layoutToShow?.length > 0 && { background: "primary" })}>
                    {isDesktop && !isTablet && (
                        <Box position="relative">
                            <Notification scopeToShow="menu" />
                            <Notification scopeToShow="desktop" />
                        </Box>
                    )}
                    <Row
                        {...(!isDesktop && {
                            className: "display-flex flex-column justify-content-between",
                            gapY: "0",
                        })}
                        fullHeight>
                        <Col xs={12} className="desktop-main">
                            {isDesktop && this.renderHeader()}
                            {isDesktop && <EntrustDisclaimerComponent />}
                            {type !== CORPORATE_ENVIRONMENT_TYPE && isDesktop && (
                                <ScheduledTransactionsMigrationDisclaimer />
                            )}
                            {type === CORPORATE_GROUP_ENVIRONMENT_TYPE && <EconomicGroups />}
                            {!isDesktop && (
                                <>
                                    <ShortCuts dashboard options={shortCutBtns} inverse isStepZero={isStepZero} />
                                    <FastRechargeCarousel
                                        sliderList={listPayService}
                                        onClick={(service) => this.handleLinkFastRecharge(service)}
                                    />
                                </>
                            )}
                            {!isDesktop && (
                                <div className={classNames("mx-n-5 px-5 px-md-0", "background-white")}>
                                    <EntrustDisclaimerComponent
                                        redirectSuccess="/desktop"
                                        redirectError="/desktop"
                                        scopeSuccess={["desktop"]}
                                        scopeError={["desktop"]}
                                        redirectAbort="/desktop"
                                    />
                                    {type !== CORPORATE_ENVIRONMENT_TYPE && (
                                        <ScheduledTransactionsMigrationDisclaimer
                                            redirectSuccess="/desktop"
                                            redirectError="/desktop"
                                            scopeSuccess={["desktop"]}
                                            scopeError={["desktop"]}
                                        />
                                    )}
                                </div>
                            )}
                            {layoutToShow?.length > 0 && (
                                <>
                                    <DraggableList
                                        columns={this.getColumns(layoutToShow)}
                                        isDragEnabled={isEditable}
                                        itemRenderer={this.renderItem}
                                        onItemsPositionChange={this.handleItemsPositionChange}
                                    />
                                </>
                            )}
                            {widgetToDelete && showDeleteWidgetModal ? (
                                <TextAndButtonsModal
                                    modalShow={showDeleteWidgetModal}
                                    acceptFunction={this.handleClick}
                                    cancelFunction={this.hideDeleteWidgetModal}
                                    headingText={i18n.get("widgets.hideModal.modal.headingText")}
                                    text={infoMessage}
                                />
                            ) : (
                                <></>
                            )}
                            {/* {this.renderModalUpdateDataUser()} */}
                            {/* type === CORPORATE_ENVIRONMENT_TYPE &&
                            (permissions.settingsCorporateDataUpdate || isAdministrator) &&
                            showUpdateCorporateDataModal ? (
                                <TextAndButtonsModal
                                    modalShow
                                    acceptFunction={
                                        isMobile
                                            ? this.handleCloseUpdateCorporteModal
                                            : this.displayUpdateCompanyDataStepZero
                                    }
                                    {...(!isMobile && { cancelFunction: this.handleCloseUpdateCorporteModal })}
                                    headingText={headingTextMessageUpdateModal}
                                    text={infoMessageUpdateCorporateModal}
                                    confirmLabel={
                                        isMobile ? "showAcceptOptionText" : "widgets.updateModal.confirmLabel"
                                    }
                                    cancelLabel="widgets.updateModal.cancelLabel"
                                    modalId="widgets.update.data.modal"
                                />
                            ) : (
                                <></>
                            ) */}
                            {/*
                                        <Info1
                                            label="desktop.widgets.product.request.label"
                                            btnLabel="desktop.widgets.product.request.btn"
                                            href="/settings/pointsOfInterest"
                                        />
                                     */}
                            {!isMobile && (
                                <A11yNav
                                    position="relative"
                                    // TODO (LABEL a11y)
                                    ariaLabel="Atajo  en Sección Principal"
                                    buttonList={[
                                        { label: "Ir a Menu Principal", focusOnSection: "menu" },
                                        {
                                            label: "Volver al inicio",
                                            focusOnSection: "main",
                                        },
                                    ]}
                                />
                            )}
                        </Col>
                        {layoutToShow?.length === 0 && type !== CORPORATE_GROUP_ENVIRONMENT_TYPE && (
                            <Col
                                xs={12}
                                {...(!isDesktop && { className: "display-flex full-height justify-content-center" })}>
                                <Box display="flex" alignY="center" alignX="center" className="no-widget-box">
                                    <GeneralMsg
                                        title={<Text size="5" color="text" labelKey="widgets.list.empty.title" />}
                                        imagePath="images/icons/noWidgets.svg"
                                        descriptionNode={
                                            isDesktop ? (
                                                <>
                                                    <Text size="6" labelKey="widgets.list.empty.description" />

                                                    <Button
                                                        onClick={() => this.handleIsEditableChange()}
                                                        bsStyle="link"
                                                        className="px-2 py-0 remove-min-height "
                                                        id="editDashboardBtnSecondary"
                                                        secondary>
                                                        <Text
                                                            size="5"
                                                            bold
                                                            color="heading"
                                                            labelKey="desktop.editLayout.edit.label"
                                                        />
                                                    </Button>
                                                </>
                                            ) : null
                                        }
                                    />
                                </Box>
                            </Col>
                        )}
                        {!isDesktop && displayCampaigns ? (
                            <Box background="white" className="mx-n-5">
                                <Col
                                    className="campaign-wrapper px-5"
                                    xs={12}
                                    md={6}
                                    mdOffset={isTablet ? 3 : 0}
                                    lg={12}>
                                    <Box className="campaigns-slider-wrapper-dashboard" fullWidth>
                                        <Campaigns
                                            className="mx-md-0 my-0 my-md-5 my-lg-0"
                                            isDesktop={isDesktop}
                                            section="desktop"
                                        />
                                    </Box>
                                </Col>
                            </Box>
                        ) : null}
                    </Row>
                </MainContainer>
                {isDesktop && (
                    <Box
                        component="aside"
                        id="fast-access"
                        display="flex"
                        column
                        className="sidebar-right-wrapper"
                        ariaLabel="Sidebar de escritorio"
                        position="relative">
                        <Row heightAuto className="align-items-center px-0">
                            {isDesktop && !isTablet ? (
                                <Col xs={12}>
                                    <Box border="bottom-background-divider-1" className="pb-8">
                                        <ShortCuts
                                            className="mt-7"
                                            isDesktop
                                            options={shortCutBtns}
                                            isStepZero={isStepZero}
                                        />
                                    </Box>
                                </Col>
                            ) : null}

                            {/* <Col xs={12} md={campaigns?.length > 0 ? 6 : 12} lg={12}>
                                <PaymentCards />
                            </Col> */}

                            {displayCampaigns ? (
                                <Col
                                    xs={12}
                                    md={6}
                                    mdOffset={isTablet ? 3 : 0}
                                    lg={12}
                                    {...(!isDesktop && { className: "mb-8" })}>
                                    <Box className="campaigns-slider-wrapper-dashboard">
                                        <Campaigns
                                            className="mx-5 mx-md-0 my-0 my-md-5 my-lg-0"
                                            isDesktop={isDesktop}
                                            section="desktop"
                                        />
                                    </Box>
                                </Col>
                            ) : null}
                            {!isMobile && (
                                <Col xs="12">
                                    <A11yNav
                                        position="relative"
                                        // TODO (LABEL a11y)
                                        ariaLabel="Atajo en Transacciones rápidas"
                                        buttonList={[
                                            { label: "Ir a Sección principal", focusOnSection: "main" },
                                            { label: "Ir a Menu Principal", focusOnSection: "menu" },
                                        ]}
                                        column
                                    />
                                </Col>
                            )}
                        </Row>
                    </Box>
                )}
            </>
        );
    };

    render() {
        const {
            sessionFetching,
            desktopFetching,
            isDesktop,
            dispatch,
            showMonitorFraudModal,
            drawerTokenStatusType,
            showDrawerStatusToken,
        } = this.props;

        return (
            <>
                {deviceUtils.isMobileNativeFunc() && !(sessionFetching || desktopFetching) && !this.hasModalShow() && (
                    <BiometricModal />
                )}
                {!isDesktop && this.renderHeader()}
                {isDesktop ? (
                    <Box component="section" className="dashboard-section">
                        {this.renderContent()}
                    </Box>
                ) : (
                    this.renderContent()
                )}
                <ConfirmDialog
                    showDialog={showMonitorFraudModal}
                    description={i18n.get("configuration.monitor.fraud.modal") || ""}
                    onConfirm={() => dispatch(actions.hideMonitorFraudModal())}
                    confirmLabel="global.accept"
                    textClassName="mx-md-5"
                />
                {drawerTokenStatusType && (
                    <SideBarModal
                        show={showDrawerStatusToken ?? false}
                        onClose={() => {
                            dispatch(actions.hideDrawerStatusToken());
                        }}
                        title={`token.drawer.${drawerTokenStatusType}.title`}>
                        <TokeStatusQR tokenStatus={drawerTokenStatusType} />
                    </SideBarModal>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    availableWidgets: desktopSelectors.getAvailableWidgets(state),
    layout: desktopSelectors.getLayout(state),
    isEditable: desktopSelectors.getIsEditale(state),
    sessionFetching: sessionSelectors.isFetching(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    user: sessionSelectors.getUser(state),
    desktopFetching: desktopSelectors.isFetching(state),
    displayCampaigns: loginSelectors.getDisplayCampaigns(state),
    urlFooterBanner: desktopSelectors.urlFooterBanner(state),
    showUpdateDataModal: desktopSelectors.updateModalShow(state),
    daysSinceLastUpdt: desktopSelectors.getDaysSinceLastUpdt(state),
    showUpdateCorporateDataModal: desktopSelectors.updateCorporateModalShow(state),
    yearsSinceLastUpdtCorporate: desktopSelectors.getYearsSinceLastUpdtCorporate(state),
    isAdministrator: sessionSelectors.isAdministrator(state),
    listPayService: payServiceSelectors.getListFastRecharge(state),
    payServiceFetching: payServiceSelectors.isFetching(state),
    showMonitorFraudModal: desktopSelectors.showMonitorFraudModal(state),
    drawerTokenStatusType: desktopSelectors.getDrawerTokenStatusType(state),
    showDrawerStatusToken: desktopSelectors.isShowDrawerStatusToken(state),
});

export default connect(mapStateToProps)(Desktop);
